<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm margem" style="width: 80vw" @click.stop>
            <div class="alinha-centro">
                <h2>{{ entregaSelecionada?.nome }}</h2>
                <span class="txt-erro">Atenção: tarefas sem datas de planejamento não serão incluídas no gráfico.</span>
            </div>
            <GraficoGant :sprints="sprints" :is-auditor="isAuditor" :is-coordenador="isCoordenador" />
        </div>
    </div>
</template>

<script>
import GraficoGant from "@/components/GraficoGant.vue";

export default {
    name: "ModalGraficoSprints",
    components: { GraficoGant },
    props: {
        mostrar: { type: Boolean, default: false },
        entregaSelecionada: { type: Object, default: () => ({}) },
        sprints: { type: Array, default: () => [] },
        isAuditor: { type: Boolean, default: false },
        isCoordenador: { type: Boolean, default: false },
    },
    emits: ["fechar"],
};
</script>
